import { SkeletonLoaderDiv } from "_shared/styles/skeletonLoader";
import styled from "styled-components"

export const ChartDetailContainer = styled(SkeletonLoaderDiv)`
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  line-height: 18px;
  gap: 8px;
  display: inline-flex;
  ${props => props.isLoading && `width: 120px;`}
`;

type ChartDetailRectProps = {
	color: string;
}
export const ChartDetailRect  = styled.div<ChartDetailRectProps>`
  width: 12px;
  height: 12px;
  background: ${props => props.color};
  border-radius: 2px;
`;

export const ChartDetailFulltext  = styled.div`
  color:#2B2B2B;
  font-size: 14px;
  font-family: 'Source Sans Pro';
  line-height: 18px;
  word-wrap: break-word;
`;

export const ChartDetailValue = styled.span`
  font-weight: 700;
`;
export const ChartDetailText = styled.span`
  font-weight: 400;
`;

